import React from "react";
import { IoAddOutline } from "react-icons/io5";

import styles from "./customChallenges.module.css";

export function AddCategory({ onClick }) {
  return (
    <div>
      <button
        onClick={onClick}
        type="button"
        className={`${styles.add} touchable-opacity`}
      >
        <IoAddOutline size={38} />
      </button>
    </div>
  );
}

export function CategoryCard({ className = "", children, index, handleClick }) {
  return (
    <div
      className={`zoom-in`}
      style={{
        "--animation-delay": `${index * 0.1}s`,
        "--animation-duration": ".5s",
      }}
    >
      <button
        onClick={handleClick}
        type="button"
        className={`${styles.edit} touchable-opacity ${className}`}
      >
        {children}
      </button>
    </div>
  );
}
